import AMCFundTableNew from '../../amc/amcFundTableNew';
import { Component } from 'react';
const KEY_RATIOS = [
  {
    title: 'Ratio',
    textClass: 'lil-text-s-14 lil-font-semibold',
  },
  {
    title: 'This Fund',
    textClass: 'lil-text-s-14 lil-font-semibold',
  },
  {
    title: 'Category Avg',
    textClass: 'lil-text-s-14 lil-font-semibold',
  },
  {
    title: 'Insight',
    textClass: 'lil-text-s-14 lil-font-semibold',
  },
];
class KeyRatiosDesktop extends Component<any> {
  private getInsightPara(insight: any) {
    let para;
    switch (insight.type) {
      case 'ALPHA':
      case 'SHARPE':
        para =
          insight.fund > insight.catgory ? (
            <span style={{ color: '#30A882' }} className="lil-text-base">
              Better than category avg
            </span>
          ) : (
            <span style={{ color: '#D0483D' }} className="lil-text-base">
              Worse than category avg
            </span>
          );
        break;
      case 'BETA':
      case 'CAPTURE':
        para =
          insight.fund < insight.catgory ? (
            <span style={{ color: '#30A882' }} className="lil-text-base">
              Better than category avg
            </span>
          ) : (
            <span style={{ color: '#D0483D' }} className="lil-text-base">
              Worse than category avg
            </span>
          );
        break;
      default:
        break;
    }
    return para;
  }
  private getTableItems(insights: any) {
    const a = insights.map(ele => {
      const insightPara = this.getInsightPara(ele);
      return {
        rowItems: [
          {
            className: '',
            component: <span className="lil-text-base">{ele.title}</span>,
          },
          {
            className: '',
            component: <span className="lil-text-base">{ele.fund}%</span>,
          },
          {
            className: '',
            component: <span className="lil-text-base">{ele.catgory}%</span>,
          },
          {
            className: '',
            component: <span className="lil-text-base">{insightPara}</span>,
          },
        ],
      };
    });
    return a;
  }
  public render() {
    return (
      <AMCFundTableNew
        itemtype="http://schema.org/Table"
        itemprop="about"
        title={'Key Ratios'}
        headingData={KEY_RATIOS}
        titleLowerCase={true}
        bodyData={this.getTableItems(this.props.insights)}
      >
        {' '}
      </AMCFundTableNew>
    );
  }
}

export default KeyRatiosDesktop;



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/keyRatios/keyRatiosDesktop.tsx